
import React, { useState, useEffect, Fragment, useRef } from 'react'
import {
  Select, Form, Input, Button, Modal,
  Upload, Row, Col, Switch, message, InputNumber, Space, Radio, TreeSelect, Tree
} from "antd";
import { PlusSquareOutlined, MinusSquareOutlined, EditFilled, DeleteOutlined } from '@ant-design/icons';
// import { LoadingOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
// import HandleButton from "@/components/HandleButton"
import RoleApi from '@api/role'

import ResourceApi from '@api/resource'
// import Title from '@/components/Title'
// import MinTitle from '@/components/MinTitle'
// import MessageApi from '@api/message'
import AddModal from '@components/Modal'
import moment from 'moment';
// const { UPLOADER } = window.globalConfig;
import { alarmApi, stationApi, dictApi } from "@api/newApi";
import InspectionApi from '@api/inspect'
import { treeConversion, treeIds, extraIds, cycleData } from '@utils/common'
import { List } from 'immutable';

const layout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 21 },
};
const { SHOW_PARENT, SHOW_ALL, TreeNode } = TreeSelect;
const Option = Select.Option
let childIds = ''
export default ({ title, visible, formData = null, cancel, stationData }) => {
  const [form] = Form.useForm();
  const [editBool, setEditBool] = useState(false)
  const [formValue, setFormValue] = useState()
  const [loading, setLoading] = useState()

  const [contentData, setContentData] = useState([])

  useEffect(() => {
    if (!!formData) {
      console.log(formData)
      getInfo(formData.id)
    }
    return () => { }
  }, [formData])

  const getInfo = (id) => {
    InspectionApi.getInfo(id).then(res => {
      if (res.status == '0') {
        console.log(res.data, 'xxxxx')
        form.setFieldsValue({
          'templateName': res.data.templateName
        })
        setFormValue(res.data)
        setContentData(res.data.patrolTemplateItemInfos.map(v => {
          return {
            ...v,
            isSafetyPeril: v.isSafetyPeril ? true : false,
            runningState: v.runningState ? true : false
          }
        }))
      }
    })
  }
  // 提交
  const submit = () => {
    form.validateFields().then(values => {
      if (!values) {
        return
      }
      if (contentData.some(v => !v.itemContent)) {
        message.warning('请完善模版内容信息！')
        return
      }
      setLoading(true)
      let param = {
        ...values,
        patrolTemplateItems: contentData.map(v => {
          return {
            itemContent: v.itemContent,
            isSafetyPeril: v.isSafetyPeril ? 1 : 0,
            runningState: v.runningState ? 1 : 0
          }
        })
      }
      if (formValue.id) {
        param.id = formValue.id
        InspectionApi.update(param).then(res => {
          if (res.status == 0) {
            message.success('编辑成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
        })
      } else {
        InspectionApi.add(param).then(res => {
          if (res.status == 0) {
            message.success('新建成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
        })
      }
    })
  }
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  }

  const addContent = () => {
    let con = contentData.length && contentData[contentData.length - 1].itemContent
    if (contentData.length && !con) {
      message.warning('请完善当前信息')
      return
    }
    setContentData([
      ...contentData,
      { itemContent: '', runningState: false, isSafetyPeril: false }
    ])
  }
  const delContent = (i) => {
    let data = [...contentData]
    data.splice(i, 1)
    console.log(data, i)
    setContentData(data)
  }
  const setDataAttr = (i, attr, val) => {
    let data = [...contentData]
    data[i][attr] = val
    setContentData([...data])
  }
  const num = contentData.length || 0
  return (
    <AddModal title={title} footer={[
      <Row key={'btn'} span={24}>
        <Button key={1} onClick={handelCancel} className='abuttons'>
          <i className='iconfont iconfanhui'>
          </i>&nbsp;&nbsp;取消
        </Button>
        <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
          <i className='iconfont iconbaocun'>
          </i>&nbsp;&nbsp;保存
        </Button>
      </Row>]
    } visible={visible} width={800} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
      <div className='userModal'>
        <Form
          {...layout}
          layout="horizontal"
          form={form}
          style={{ marginTop: '20px' }}
        >
          {/* <Row> */}
          <Col span={24}>
            <Form.Item
              label='模版名称'
              name="templateName"
              rules={[{ required: true, message: '请输入资源名称!' }]}
            >
              <Input disabled={editBool} style={{ width: '200px' }} placeholder={'请输入资源名称'} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label='模版内容'
              name="content"
            >
              <Button onClick={() => addContent()}>新增</Button>
              {num && contentData.map((v, i) => {
                return (
                  <Row key={'row' + i + v.itemContent} style={{ marginBottom: '10px' }}>
                    <Col span={20} style={{ display: 'flex', alignItems: 'center' }}>
                      <Input defaultValue={contentData[i].itemContent} style={{ width: '200px' }} onBlur={(e) => setDataAttr(i, 'itemContent', e.target.value)} placeholder={'巡检内容'} />
                      <Col style={{ margin: '0 20px' }}>
                        <span>安全隐患：</span><Switch checked={v.runningState} onChange={(e) => setDataAttr(i, 'runningState', e)} checkedChildren="是" unCheckedChildren="否" />
                      </Col>
                      <Col>
                        <span>运行状态：</span><Switch checked={v.isSafetyPeril} onChange={(e) => setDataAttr(i, 'isSafetyPeril', e)} checkedChildren="运行" unCheckedChildren="热备" />
                      </Col>
                    </Col>
                    <Col span={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }} >
                      <PlusSquareOutlined onClick={() => addContent()} style={{ fontSize: '24px', color: '#2D99FF', marginLeft: '20px' }} />
                      {(num > 1) && < MinusSquareOutlined onClick={() => delContent(i)} style={{ fontSize: '24px', color: '#2D99FF' }} />}
                    </Col>
                  </Row>
                )
              }) || null}
            </Form.Item>
          </Col>
        </Form>
      </div>
    </AddModal>
  )

}
